<template>
  <v-row dense>
    <v-col cols="12" xl="12">
      <v-card elevation="0" class="all-trade-tab rounded-0 mb-0"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
        <div class="mt-0 px-4 pt-8 pb-3">
          <div class="titleName d-flex align-center">
            <v-img class="mr-2" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
            <span>Your Childs Level</span>
          </div>
        </div>
        <v-tabs :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
          " class="pa-0">
          <v-tab v-for="(tab, index) in generateLevelsArray" :key="index">{{
            tab
          }}</v-tab>

          <v-tab-item v-for="(tab, index) in generateLevelsArray" :key="index">
            <v-card flat>
              <v-card :class="$vuetify.theme.dark
                  ? 'blue-darken-2 pt-4'
                  : 'white-lighten-2 pt-4'
                ">
                <v-row dense v-if="tab !== 'Level Earning Chart'">
                  <v-col cols="12" sm="8" md="8" lg="8">
                    <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..."
                      single-line solo hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4">
                    <ul>
                      <li>
                        <span class="text--ash">Total Lot:</span>
                        <span>
                          {{
                            clienttree?.levelWiseSummary?.[
                              tab?.toLowerCase()?.replace(" ", "_") + "_summary"
                            ]?.totalSize
                          }}
                        </span>
                      </li>
                      <li>
                        <span class="text--ash">Total Trade:</span>
                        <span>
                          {{
                            clienttree?.levelWiseSummary?.[
                              tab?.toLowerCase()?.replace(" ", "_") + "_summary"
                            ]?.totalTrades
                          }}</span>
                      </li>
                      <li>
                        <span class="text--ash">Commission:</span>
                        <span>
                          {{
                            clienttree?.levelWiseSummary?.[
                              tab?.toLowerCase()?.replace(" ", "_") + "_summary"
                            ]?.totalCommission
                          }}</span>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-card class="rounded-0 elevation-0" :class="$vuetify.theme.dark
                        ? 'blue-darken-5'
                        : 'white-lighten-2'
                      ">
                      <div v-if="tab === 'Level Earning Chart'">
                        <ClientLevelChart></ClientLevelChart>
                      </div>
                      <v-sheet v-else class="transactionTable levelOneTable" :class="$vuetify.theme.dark
                          ? 'blue-lighten-1 '
                          : 'white-lighten-1'
                        ">
                        <v-data-table :headers="headers" :items="clienttree?.[
                          'level_' +
                          Number(tab?.replace(/^\D+/g, '')) +
                          '_clients'
                          ]
                          " :search="search" :items-per-page="10">
                          <template v-slot:item.symb="{ item }">
                            <div class="user-profile">
                              <div class="profile-image">
                                <v-badge bordered overlap small icon="mdi-star-outline" size="10"
                                  :class="verifyBadge(item?.totalClients)">
                                  <v-avatar size="32" class="green-darken-2">
                                    <span class="text-small">L{{
                                      Number(tab?.replace(/^\D+/g, ""))
                                    }}</span>
                                  </v-avatar>
                                </v-badge>
                              </div>
                            </div>
                          </template>
                          <template v-slot:item.client_name="{ item }">
                            {{ item?.client_name }}({{ item?.client_id }})
                          </template>
                          <template v-slot:item.commission="{ item }">
                            <span class="text-capitalize text-decoration-none text--green">
                              {{ item?.commission }}
                            </span>
                          </template>
                          <template v-slot:item.reg_time="{ item }">
                            {{
                              item?.reg_time
                            }}
                          </template>
                          <template v-slot:item.accounts="{ item }">
                            {{ item?.accounts?.length }}
                          </template>
                          <template v-slot:item.totalClients="{ item }">
                            <v-btn outlined small :class="verifyClients(item?.totalClients)"
                              :disabled="item?.totalClients === 0">
                              <div class="see-clients-links text-decoration-none text-capitalize"
                                @click="seeClientsById(item?.client_id)">
                                See Clients:
                                <span>{{ item?.totalClients }}</span>
                              </div>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-sheet>
                    </v-card>
                    <!-- <div style="display: flex; justify-content: flex-end">
                    <v-btn @click="exportToExcel">
                      <v-icon>mdi-file-excel</v-icon> Export File
                    </v-btn>
                  </div> -->
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CLIENTTREE__ACTIONS } from "@/store/action-types";
import ClientLevelChart from "../../Dashboard/ClientLevelChart";

export default {
  components: {
    ClientLevelChart,
  },
  data() {
    return {
      search: "",
      slots: ["All", "Deposit", "Withdrawal", "Internal Transfer"],
      selectedTransactionType: null,
      selectedTransactionLevel: null,
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      headers: [
        {
          text: "Symb",
          align: "center",
          value: "symb",
        },
        { text: "Client Name", value: "client_name", align: "center" },
        { text: "Parent ID", value: "parent_id", align: "center" },
        { text: "Reg Date & TIme", value: "reg_time", align: "center" },
        { text: "Accounts", value: "accounts", align: "center" },
        { text: "Total Deposit", value: "balance", align: "center" },

        {
          text: "Commission",
          value: "totalCommissionEarning",
          align: "center",
        },
        { text: "See Clients", value: "totalClients", align: "center" },
      ],
    };
  },
  computed: {
    ...mapState("clienttree", ["clienttree"]),

    generateLevelsArray() {
      const levelsArray = [];
      for (let i = 0; i < this.clienttree?.businessLevel; i++) {
        levelsArray.push(`Level ${i + 1}`);
      }
      return ["Level Earning Chart", ...levelsArray];
    },
  },
  methods: {
    ...mapActions("clienttree", [CLIENTTREE__ACTIONS.CLIENTTREE]),

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        // Ensure both start and end dates are selected
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        // Swap dates if necessary
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    verifyBadge(totalClients) {
      if (totalClients > 0) return "show-badge";
      else return "hide-badge";
    },

    verifyClients(totalClients) {
      if (totalClients > 0) return "active-clients-btn";
      else return "inActive-clients-btn";
    },

    async seeClientsById(id) {
      const parameter = {
        parentID: id,
      };

      this[CLIENTTREE__ACTIONS.CLIENTTREE](parameter);
    },

    exportToExcel() {
      // Add your export logic here
      console.log("Exporting to Excel...");
    },
  },
  mounted() {
    this[CLIENTTREE__ACTIONS.CLIENTTREE]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
